import { requestWithToken as request } from './api'

export const getUserCompanies = (params = {}) => {
  return request.get('/custom_admin/user_company/?format=json',
    params)
}
